const eventHistoryTable = {
    bindings: {
        eventHistory: '<',
        selectedEnvData: '<',
        loadBusy: '<',
        loadMore: '&'
    },
    templateUrl: '/modules/analysis/event-history-table/event-history-table.html',
    controller: 'EventHistoryTableController',
};

angular
    .module('analysis.module')
    .component('eventHistoryTable', eventHistoryTable);